import { DateTime } from 'luxon';
import type { ICall } from '../models/call.model';

export class CallHelper {
  public static isDelayed(call: ICall): boolean {
    return !!call.estimatedTime && call.estimatedTime > call.plannedTime;
  }

  public static isOnTime(call: ICall): boolean {
    return !call.estimatedTime || call.estimatedTime.equals(call.plannedTime);
  }

  public static getTime(call: ICall, useEstimatedTime: boolean): DateTime {
    if (useEstimatedTime) {
      return call.estimatedTime ? call.estimatedTime : call.plannedTime;
    }
    return call.plannedTime;
  }
}
